function verificaFaculdade(realizado) {
    let novoRealizado = JSON.parse(JSON.stringify(realizado))
    let { unidade, modalidades } = novoRealizado;

    let obj = Object.keys(modalidades).reduce((acc, atual) => {

        let isFaculdade = ['41 G', '87 C', '91 P', 'Graduação', 'Pós-Graduação', 'Cursos de Extensão'].some(v => atual.startsWith(v))
        if(isFaculdade) acc.faculdade[atual] = modalidades[atual]
        else acc.ep[atual] = modalidades[atual]
        return acc

    }, { ep: {}, faculdade: {} })

    let { ep, faculdade } = obj
    return {
        ep: { unidade, modalidades: ep },
        faculdade: { unidade, modalidades: faculdade }
    }

}

function calculaTotal(realizados) {
    if(!realizados) return
    let modalidades = realizados.modalidades;
    let obj = {
        meta: {
            matricula_regimental: 0,
            matricula_nao_regimental: 0,
            matricula_pago: 0,
            hora_regimental: 0,
            hora_nao_regimental: 0,
            hora_pago: 0
        },
        retificada: {
            matricula_regimental: 0,
            matricula_nao_regimental: 0,
            matricula_pago: 0,
            hora_regimental: 0,
            hora_nao_regimental: 0,
            hora_pago: 0
        }
    }
    Object.keys(modalidades).map(modalidade => {
        let meta = modalidades[modalidade]['meta']
        let realizado = modalidades[modalidade]['retificada']
        Object.keys(meta).map(financiamento => obj['meta'][financiamento] += meta[financiamento])
        Object.keys(realizado).map(financiamento => obj['retificada'][financiamento] += realizado[financiamento])
    })
    return obj;
}

export default { verificaFaculdade, calculaTotal }
